import {
      UserDetails
    , LocationSettingsContext
    , Layer
    , ModeSettings
} from "./context";

const defaultLayer: Layer = {
    layerId: 0,
    layerName: "New Layer",
    shapes: [],
    hidden: false
}

const defaultUserDetails: UserDetails = {
    email: '',
    userId: '',
    fullName: '',
    role: 'user',
    customerId: null,
    customerName: null,
    companyRole: null,
}

const defaultLocationSettings: LocationSettingsContext = {
    latitude: -32.926034114093284,
    longitude: 151.76150787192498,
    zoom: 13
}

const defaultMapSettings = {
    basemap: 'standard'
}

const defaultModeSettings: ModeSettings = {
    mode: "",
    drawingPolygonPoints: [],
    drawingLinePoints: [],
    editingPolygonId: null,
    editingVertexIndex: null
}

export {
      defaultUserDetails
    , defaultLocationSettings
    , defaultLayer
    , defaultModeSettings
    , defaultMapSettings
}

